import React from "react";

export type IconHiveryProps = {
  width: string;
  height: string;
};

export const IconHivery = ({ width, height }: IconHiveryProps) => (
  <svg
    width={width}
    height={height}
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 55 55`}
    fill="currentColor"
  >
    <path
      transform="translate(4, 0)"
      d="M26.06,52.27,12.52,44.42V31.1L1,24.43V8.86L14.56,1l11.5,6.66L37.55,1,51.12,8.87V24.43L39.6,31.1V44.42ZM16.55,42.1l9.51,5.51,9.51-5.51V28.78L47.09,22.1V11.19L37.55,5.65,26.06,12.31,14.56,5.65,5,11.18V22.11l11.52,6.67Z"
    />
  </svg>
);
